var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowConfirm
    ? _c(
        "confirm",
        {
          staticClass: "middle no-padding-confirm",
          attrs: {
            closeIcon: true,
            close: _vm.hide,
            btnUnuse: _vm.unTrans,
            isLoading: _vm.isLoading,
            title: _vm.$t("tokenCard.actionType.EXTRANSFER"),
            leftBtnTxt: _vm.$t("btn.cancel"),
            leftBtnClick: _vm.hide,
            rightBtnTxt: _vm.$t("btn.submit"),
            rightBtnClick: _vm.submit
          }
        },
        [
          _c("div", { staticClass: "transfer-head" }, [
            _c("div", { staticClass: "point" }, [
              _c("div", { staticClass: "line" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "describe" }, [
              _c("div", { staticClass: "line" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("tokenCard.transferConfirm.from")))
                ]),
                _vm._v(_vm._s(_vm.from))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("tokenCard.transferConfirm.to")))
                ]),
                _vm._v(_vm._s(_vm.to))
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "switch __pointer",
              on: { click: _vm.switchTransfer }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(
                _vm._s(_vm.$t("tokenCard.transferConfirm.avaliableAmount"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
              _c("img", {
                staticClass: "__icon",
                attrs: { src: _vm.tokenInfo.icon }
              }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.tokenInfo.tokenSymbol) +
                  "\n            "
              ),
              _c("span", { staticClass: "__right" }, [
                _vm._v(_vm._s(_vm.basicAvailableAmount))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("wallet.sum")) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.amountErr,
                        expression: "amountErr"
                      }
                    ],
                    staticClass: "__err"
                  },
                  [_vm._v(_vm._s(_vm.amountErr))]
                )
              ]),
              _vm._v(" "),
              _c(
                "vite-input",
                {
                  attrs: {
                    valid: _vm.validAmount,
                    placeholder: _vm.$t("wallet.placeholder.amount")
                  },
                  on: { input: _vm.noAll },
                  model: {
                    value: _vm.amount,
                    callback: function($$v) {
                      _vm.amount = $$v
                    },
                    expression: "amount"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "__all_wrapper __pointer",
                      attrs: { slot: "after" },
                      on: { click: _vm.all },
                      slot: "after"
                    },
                    [
                      _c("span", { staticClass: "__all" }, [
                        _vm._v(_vm._s(_vm.$t("tradeAssets.all")))
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }